// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__3sm4T","text":"text__MALwE","heading":"heading__2tRIZ","subHeading":"subHeading__MKLBT","container":"container__3cuvR"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVD/whyCardlessEmi/advantageCard/style.css
// module id = unz1
// module chunks = 446